export default [
    {
        path: '/channels',
        name: 'channels',
        meta: {
            access: ['AUTH_SETTING_CHANNEL'],
            title: 'channels',
            icon: 'icon-qudao',
            notPageView: true,
        },
        // redirect: { name: 'channels_chat_list' },
        component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/layout.vue'),
        children: [
            {
                path: 'chat',
                name: 'channels_chat',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_chat',
                    icon: 'icon-qudao',
                    notPageView: true,
                },
                redirect: { name: 'channels_chat_list' },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Chat/index.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'channels_chat_list',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_chat_list',
                            icon: 'icon-qudao',
                        },
                        component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Chat/List.vue'),
                    },
                    {
                        path: 'new',
                        name: 'channels_chat_new',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_chat_list',
                            icon: 'icon-qudao',
                        },
                        component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Chat/Edit/Edit.vue'),
                    },
                    {
                        path: ':id',
                        name: 'channels_chat_edit',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_chat_edit',
                            icon: 'icon-qudao',
                        },
                        component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Chat/Edit/Edit.vue'),
                    },
                ],
            },
            {
                path: 'messenger',
                name: 'channels_messenger_page',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_messenger_page',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Facebook/Page/List.vue'),
            },
            {
                path: 'messenger/page',
                name: 'channels_messenger_page',
                redirect: { name: 'channels_messenger_page' },
            },
            {
                path: 'messenger/auth',
                name: 'channels_messenger_auth',
                redirect: { name: 'channels_messenger_page' },
            },
            {
                path: 'email',
                name: 'channels_email',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_email',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Email/List.vue'),
            },
            {
                path: 'youtube',
                name: 'channels_youtube',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_youtube',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Youtube/index.vue'),
            },
            {
                path: 'instagram',
                name: 'channels_instagram',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_instagram',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Instagram/index.vue'),
            },
            {
                path: 'telegram',
                name: 'channels_telegram',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_telegram',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Telegram/index.vue'),
            },
            {
                path: 'line',
                name: 'channels_line',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_line',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Line/index.vue'),
            },
            {
                path: 'whatsapp',
                name: 'channels_whatsapp',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_whatsapp',
                    icon: 'icon-qudao',
                    notPageView: true,
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Whatsapp/index.vue'),
                // redirect: { name: 'channels_whatsapp_platform' },
                children: [
                    {
                        path: 'platform',
                        name: 'channels_whatsapp_platform',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_whatsapp',
                            icon: 'icon-qudao',
                        },
                        component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Whatsapp/PlatformList.vue'),
                    },
                    {
                        path: 'third_party',
                        name: 'channels_whatsapp_third_party',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_whatsapp',
                            icon: 'icon-qudao',
                        },
                        component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Whatsapp/ThirdPartyList.vue'),
                    },
                    /* todo 待移除 start */
                    {
                        path: 'business',
                        name: 'channels_whatsapp_business',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_whatsapp',
                            icon: 'icon-qudao',
                        },
                        redirect: { name: 'channels_whatsapp_third_party' },
                    },
                    {
                        path: 'cloud',
                        name: 'channels_whatsapp_cloud',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_whatsapp',
                            icon: 'icon-qudao',
                        },
                        redirect: { name: 'channels_whatsapp_third_party' },
                    },
                    /* todo 待移除 end */
                    {
                        path: 'bill',
                        name: 'channels_whatsapp_bill',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'channels_whatsapp_bill',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting" */ '@/views/main/Channels/Whatsapp/Bill.vue'),
                    },
                ],
            },
            {
                path: 'weixin',
                name: 'channels_weixin',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_weixin',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Weixin/index.vue'),
            },
            {
                path: 'slack',
                name: 'channels_slack',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_slack',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Slack/index.vue'),
            },
            {
                path: 'wecom',
                name: 'channels_wecom',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_wecom',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Wecom/index.vue'),
            },
            {
                path: 'vkontakte',
                name: 'channels_vkontakte',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_vkontakte',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/VKontakte/index.vue'),
            },
            {
                path: 'tiktok_business',
                name: 'channels_tiktok_business',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_tiktok_business',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/TikTokBusiness/index.vue'),
            },
            {
                path: 'wechat',
                name: 'channels_wechat',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_wechat',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Wechat/index.vue'),
            },
            {
                path: 'individual_whatsapp',
                name: 'channels_individual_whatsapp',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_individual_whatsapp',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/IndividualWhatsApp/index.vue'),
            },
            {
                path: 'individual_telegram',
                name: 'channels_individual_telegram',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_individual_telegram',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/IndividualTelegram/index.vue'),
            },
            {
                path: 'tiktok',
                name: 'channels_tiktok',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_tiktok',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/TikTok/index.vue'),
            },
            {
                path: 'zalo',
                name: 'channels_zalo',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_zalo',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/Zalo/index.vue'),
            },
            {
                path: 'individual_line',
                name: 'channels_individual_line',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'channels_individual_line',
                    icon: 'icon-qudao',
                },
                component: () => import(/* webpackChunkName: "channels" */ '@/views/main/Channels/IndividualLine/index.vue'),
            },
        ],
    },
];
